module.exports = __webpack_public_path__ + "assets/img_hire.125d4e4c.png";